import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import "../style/Product.css";
import "../style/ProductDetails.css";
import MasterData from "../Data/masterData";

const ProductView = () => {
  const { category, type, model } = useParams();

  const motor =
    MasterData?.[category]?.subCategories
      ?.find((item) => item.id === type)
      ?.list?.find((p) => p.id === model);

  
  if (!motor) {
    return (
      <div className="product-details not-found">
        <h2>⚠ Product not found</h2>
        <Link to={`/product/${category}/${type}`}>⬅ Back</Link>
      </div>
    );
  }

  const variants = motor.variants;

  if (!variants || variants.length === 0) {
    return (
      <Navigate
        to={`/product/${category}/${type}/${motor.id}/${motor.id}`}
        replace
      />
    );
  }


  return (
    <div className="product-page">
      <h1>{motor.name}</h1>

      <div className="product-grid">
        {variants.map((variant) => (
          <div key={variant.id} className="product-card">
            <img src={variant.img} alt={variant.name} />
            <h3>{variant.name}</h3>
            <p>{variant.desc}</p>

            <Link
              to={`/product/${category}/${type}/${motor.id}/${variant.id}`}
              className="product-btn"
            >
              View Details
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductView;
